import React from 'react';
import Logo from './Logo';

const ThanksgivingGreeting = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-600 via-amber-700 to-yellow-600 flex items-center justify-center p-8">
      <div className="max-w-4xl w-full">
        {/* Main Card */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          
          {/* Decorative Top Border */}
          <div className="h-4 bg-gradient-to-r from-orange-500 via-amber-500 to-yellow-500"></div>
          
          {/* Content */}
          <div className="p-12 md:p-16 text-center relative">
            
            {/* Decorative Fall Leaves */}
            <div className="absolute top-8 left-8 text-6xl opacity-20">🍂</div>
            <div className="absolute top-12 right-12 text-5xl opacity-20">🍁</div>
            <div className="absolute bottom-12 left-16 text-5xl opacity-20">🍁</div>
            <div className="absolute bottom-8 right-8 text-6xl opacity-20">🍂</div>
            
            {/* Logo */}
            <div className="flex justify-center mb-8 relative z-10">
              <div className="bg-gray-50 p-6 rounded-2xl shadow-lg">
                <Logo />
              </div>
            </div>
            
            {/* Main Message */}
            <div className="relative z-10 space-y-6">
              <h1 className="text-5xl md:text-6xl font-black text-orange-600 mb-4">
                Happy Thanksgiving!
              </h1>
              
              <div className="flex items-center justify-center gap-4 mb-6">
                <div className="text-4xl">🦃</div>
                <div className="text-4xl">🥧</div>
                <div className="text-4xl">🌽</div>
              </div>
              
              <p className="text-2xl md:text-3xl text-gray-700 font-semibold mb-6">
                From Our Family to Yours
              </p>
              
              <div className="max-w-2xl mx-auto">
                <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-6">
                  We're grateful for your trust and partnership. Thank you for choosing 
                  <span className="font-bold text-blue-600"> HVAC Best Supply</span> for 
                  all your refrigerant needs.
                </p>
                
                <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
                  Wishing you and your loved ones a warm, wonderful Thanksgiving 
                  filled with joy, gratitude, and delicious moments! 🧡
                </p>
              </div>
              
              {/* Evergreen Offer Box */}
              <div className="mt-10 bg-gradient-to-r from-orange-50 to-amber-50 border-2 border-orange-300 rounded-2xl p-6 max-w-xl mx-auto">
                <p className="text-2xl font-bold text-orange-600 mb-2">
                  Volume Discounts Always Available
                </p>
                <p className="text-xl text-gray-700 font-semibold">
                  Free Shipping on All Orders
                </p>
                <p className="text-sm text-gray-600 mt-2">
                  Visit hvacbestsupply.com
                </p>
              </div>
              
              {/* Contact Info */}
              <div className="mt-8 pt-8 border-t-2 border-gray-200">
                <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-gray-600">
                  <div className="flex items-center gap-2">
                    <span className="text-blue-600">📧</span>
                    <span className="text-sm md:text-base">hvacbestsupply@gmail.com</span>
                  </div>
                  <div className="hidden md:block text-gray-400">|</div>
                  <div className="flex items-center gap-2">
                    <span className="text-blue-600">📞</span>
                    <span className="text-sm md:text-base">+1 562-416-1615</span>
                  </div>
                  <div className="hidden md:block text-gray-400">|</div>
                  <div className="flex items-center gap-2">
                    <span className="text-blue-600">📍</span>
                    <span className="text-sm md:text-base">Downey, California</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Decorative Bottom Border */}
          <div className="h-4 bg-gradient-to-r from-yellow-500 via-amber-500 to-orange-500"></div>
        </div>
        
        {/* Signature */}
        <div className="text-center mt-6">
          <p className="text-white text-lg font-semibold drop-shadow-lg">
            Happy Holidays from HVAC Best Supply 🍂
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThanksgivingGreeting;
